import type {
  SearchAutoCompletionParams,
  SearchDataSource,
  SearchProductsParams,
} from '~/api/data-source/search';
import { searchDataSource } from '~/api/data-source/search';
import type {
  CursorPagedMarketProducts,
  RecentSearchKeyword,
  SearchAutoCompletion,
} from '~/api/model';
import {
  cursorPagedMarketProductsSchema,
  parseModel,
  parseModelArray,
  recentSearchKeywordSchema,
  searchAutoCompletionSchema,
} from '~/api/model';

export interface SearchRepository {
  getSearchProducts(
    params: SearchProductsParams,
  ): Promise<CursorPagedMarketProducts>;
  getSearchProductsCount(params: SearchProductsParams): Promise<number>;
  getSearchAutoCompletion(
    params: SearchAutoCompletionParams,
  ): Promise<SearchAutoCompletion[]>;
  getRecentSearchKeywords(): Promise<RecentSearchKeyword[]>;
  deleteRecentSearchKeywords(keywords: string[]): Promise<unknown>;
}

export class SearchRepositoryImpl implements SearchRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: SearchDataSource = searchDataSource,
  ) {}

  async getSearchProducts(params: SearchProductsParams) {
    const response = await this.dataSource.getSearchProducts(params);
    return parseModel(
      cursorPagedMarketProductsSchema,
      response,
      'CursorPagedMarketProducts',
    );
  }

  async getSearchProductsCount(params: SearchProductsParams) {
    return this.dataSource.getSearchProductsCount(params);
  }

  async getSearchAutoCompletion(params: SearchAutoCompletionParams) {
    const response = await this.dataSource.getSearchAutoCompletion(params);
    return parseModelArray(
      searchAutoCompletionSchema,
      response,
      'SearchAutoCompletion',
    );
  }

  async getRecentSearchKeywords() {
    const response = await this.dataSource.getRecentSearchKeywords();
    return parseModelArray(
      recentSearchKeywordSchema,
      response,
      'RecentSearchKeyword',
    );
  }

  async deleteRecentSearchKeywords(keywords: string[]) {
    return this.dataSource.deleteRecentSearchKeywords(keywords);
  }
}

export const searchRepository = new SearchRepositoryImpl();
